/**
 * This is a mixin for all of the different gridlist components that provides a base line of datasource handling.
 *
 * It provides a setDataSource and cleanupDS method. When extended, there must be a _refresh and _noData method.
 */
export default {

    events: [
        "dataBinding",
        "considerRefresh",
        "dataBound"
    ],

    cleanupDS() {
        if(this.dataSource) {
            this.dataSource.unbind("change", this._refreshHandler);
            this.dataSource.unbind("requestStart", this._loadingHandler);
            this.dataSource.unbind("requestEnd", this._finishedLoadingHandler);
        }
    },

    setDataSource(dataSource) {
        this.cleanupDS();
        this._refreshHandler = $.proxy(this.refresh, this);
        this._loadingHandler = $.proxy(this._loading, this);
        this._finishedLoadingHandler = $.proxy(this._finishedLoading, this);
        this.dataSource = kendo.data.DataSource.create(dataSource);
        this.dataSource.bind("change", this._refreshHandler);
        this.dataSource.bind("requestStart", this._loadingHandler);
        this.dataSource.bind("requestEnd", this._finishedLoadingHandler);
        if(this.options.autoBind) {
            this.dataSource.fetch();
        }
    },

    dataItems() {
        return this.dataSource.flatView();
    },

    items() {
        return [];
    },

    _filterCount() {
        const config = this.dataSource.filter();
        if(config && config.filters) {
            return config.filters.length;
        } else {
            return 0;
        }
    },

    loading: $.noop,

    _loading(e) {
        if(e.type === "read") {
            this.loading(true);
        }
    },

    _finishedLoading(e) {
        if(e.type === "read") {
            this.loading(false);
        }
    },

    _isEmpty() {
        return !this.dataSource || this.dataSource.total() === 0;
    },

    _isAllDataFiltered() {
        return this._isEmpty() && this._filterCount() > this.options.filtersCount;
    },

    _minimalRefresh(e) {
        return false;
    },

    _delayedRemove(e) {
        return false;
    },

    _itemPrepareRemove: $.noop,
    _itemChange: $.noop,
    _itemAdd: $.noop,
    getItem: $.noop,

    refresh(e) {
        if(this.trigger("considerRefresh", {originalEvent: e})) {
            return;
        }
        const rows = () => e.items.map(item => this.getItem(item));
        if(e?.action === "remove" && this._delayedRemove(e)) {
            e.items.forEach(item => this._itemPrepareRemove(item, e));
        } else if(e?.action === "itemchange" && this._minimalRefresh(e)) {
            this.trigger("dataBinding", {
                removedItems: e.items.map(item => this.getItem(item))
            });
            e.items.forEach(item => this._itemChange(item, e));
            this.trigger("dataBound", {
                addedItems: rows(),
                addedDataItems: e.items
            });
        } else if(e?.action === "add" && this._minimalRefresh(e)) {
            this.trigger("dataBinding", {
                removedItems: []
            });
            e.items.forEach((item, i) => this._itemAdd(e.index + i, item, e));
            this.trigger("dataBound", {
                addedItems: rows(),
                addedDataItems: e.items
            });
        } else if(e?.action === "sync" && this._minimalRefresh(e)) {
            this.trigger("dataBinding", {
                removedItems: rows()
            });
            e.items.forEach(item => this._itemChange(item, e));
            this.trigger("dataBound", {
                addedItems: rows(),
                addedDataItems: e.items
            });
        } else if(this._isEmpty()) {
            this.trigger("dataBinding");
            this._noData(this._isAllDataFiltered());
            this.trigger("dataBound")
        } else {
            this.trigger("dataBinding");
            this._refresh(e);
            this.trigger("dataBound");
        }
    },
};
